import { SVGProps } from 'react';

function SkipToNextButton({ ...props }: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 40 37.747" {...props}>
      <g transform="translate(-10 -37.6)">
        <g transform="translate(10 37.6)">
          <path d="M36.457,81.337l-21.5-14.714A3.169,3.169,0,0,0,10,69.239V98.3a3.17,3.17,0,0,0,4.976,2.6l21.494-14.9a2.835,2.835,0,0,0-.012-4.669Z" transform="translate(-10 -64.908)" />
          <path d="M810.343,37.6a3.743,3.743,0,0,0-3.743,3.743V71.6a3.743,3.743,0,1,0,7.486,0V41.343A3.743,3.743,0,0,0,810.343,37.6Z" transform="translate(-774.086 -37.6)" />
        </g>
      </g>
    </svg>
  );
}

export default SkipToNextButton;
